import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SearchBar from "./SearchBar";
import OptionCard from './OptionCard';
import { useScore } from './context/ScoreContext';
import { getRarityFromPercentage, getParticleEffect } from './util.js'
import Hint from './Hint.js';

const Option = (props) => {
    const sNames = props.servents.map(s => s["name"]);
    const sIDs = props.servents.map(s => s["id"]);
    const validOptions = props.validOptions;
    const optionId = props.opID;
    // console.log(optionId, validOptions);

    const [showSearch, setShowSearch] = useState(false);
    const [showServentCard, setShowServentCard] = useState(false);
    const [showHint, setShowHint] = useState(false);
    const [selectedHintServantIds, setSelectedHintServantIds] = useState([]);
    const [selectedServent, setSelectedServent] = useState({ name: "", id: null });
    const [rarity, setRarity] = useState('unknown'); //
    // const [percentage, setPercentage] = useState(-1); //
    const { AddOptionState, RemoveOptionState, getOptionState, gameEnded, hintVisibleToggle } = useScore();


    useEffect(() => {

        let savedDay = localStorage.getItem(`day${props.day}`);
        if (!savedDay) return;
        savedDay = JSON.parse(savedDay);
        const slot = savedDay[optionId];
        if (slot) {
            // console.log("got here", optionId);
            let savedId = Number(slot['id']);
            const savedPercent = Number(slot['percent']);
            if (savedId > 0) {
                // console.log("sdsa");
                setSelectedServent({ name: sNames[sIDs.indexOf(savedId)], id: savedId });
                AddOptionState(optionId, savedId, savedPercent, true, false);
            } else {
                setSelectedServent({ name: "Bad Servant", id: savedId });
                AddOptionState(optionId, -1, -1, false, false);
            }

            // setPercentage(savedPercent);
            setRarity(getRarityFromPercentage(savedId, savedPercent));
            setShowSearch(false);

            const savedHintIds = savedDay[optionId]['hint'];
            // console.log(localDayData);
            if (savedHintIds && savedHintIds.length > 0) {
                setSelectedHintServantIds(savedHintIds);
            }


        }
    }, []);

    useEffect(() => {
        // console.log(gameEnded);
        if (gameEnded && !selectedServent.id) {
            setSelectedServent({ name: "Bad Servant", id: -1 });
            setRarity('wrong');
            // setPercentage(-1);
            setShowSearch(false);
        }
    }, [gameEnded]);

    const handleShowSearch = () => {
        setShowSearch(true);
        document.body.style.overflow = 'hidden';
    };

    const handleOpenServentCard = () => {
        setShowServentCard(true);
        document.body.style.overflow = 'hidden';
    };

    const handleSelectItem = (itemID) => {
        document.body.style.overflow = 'auto';
        if (validOptions.includes(itemID)) {
            AddOptionState(optionId, itemID, -2, true, true);
            setSelectedServent({ name: sNames[sIDs.indexOf(itemID)], id: itemID });
            // process.env.REACT_APP_COUNT_URL
            //'http://localhost:3001/updateCount'
            // fetch(process.env.REACT_APP_COUNT_URL, {
            //     method: 'PUT', // or 'PUT'
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify({
            //         day: props.day,
            //         slot: optionId,
            //         id: itemID,
            //         // other data to send in the request body
            //     })
            // })
            //     .then(response => response.json())
            //     .then(data => {
            //         // console.log(data);
            //         if (!data.serventCount || !data.total) return;
            //         if (data.serventCount === 1) {
            //             setRarity(getRarityFromPercentage(itemID, -100));
            //             AddOptionState(optionId, itemID, -100, false, true);
            //         } else {
            //             const p = data.serventCount / data.total;
            //             setRarity(getRarityFromPercentage(itemID, p));
            //             AddOptionState(optionId, itemID, p, false, true);
            //         }
            //     }).catch(error => {
            //         // console.error('Error:', error)
            //         // api fails:
            //     });

        } else {
            AddOptionState(optionId, -1, -1, false, true);
            setSelectedServent({ name: "Bad Servant", id: -1 });
            setRarity('wrong');
        }
        setShowSearch(false);
    };

    const handleCloseSearch = () => {
        document.body.style.overflow = 'auto';
        setShowSearch(false);
    };

    const handleCloseServentCard = () => {
        document.body.style.overflow = 'auto';
        setShowServentCard(false);
    };

    const handleUseCommandSpell = () => {
        const id = selectedServent.id;
        setSelectedServent({ name: "", id: null });
        if (id >= 0) {
            RemoveOptionState(optionId, true);
        } else {
            RemoveOptionState(optionId, false);
        }
    }

    const getServentImage = () => {
        if (selectedServent.id > 0) {
            return `https://static.atlasacademy.io/JP/Servants/Status/${selectedServent.id}/status_servant_1.png`;
        } else {
            return 'wrongOption.png';
        }
    }

    const handleOpenHint = () => {
        document.body.style.overflow = 'hidden';
        setShowHint(true);
    }

    const handleCloseHint = () => {
        document.body.style.overflow = 'auto';
        setShowHint(false);
    }

    return (

        <div className={`option border-top border-left`}>
            <AnimatePresence>
                {!selectedServent.id &&
                    <motion.div
                        initial={{ opacity: 1 }}
                        exit={{ opacity: 0, scale: 1.1, filter: "brightness(1.5)" }}
                        transition={{ duration: 0.5 }}
                        className={`option-bg ${showSearch ? 'option-bg-active' : ''}`}
                        onClick={handleShowSearch}
                    />
                }
            </AnimatePresence>

            {hintVisibleToggle && !selectedServent.id && <div className={`hint-button ${selectedHintServantIds.length ? "hint-button-selected" : ""}`} onClick={handleOpenHint}><img src="hint_icon.png" width="100%" /></div>}
            {showHint && <div><Hint opId={optionId} validIds={props.validOptions} allIds={props.servents} onClose={handleCloseHint} selectedHintIds={selectedHintServantIds} onUseHint={setSelectedHintServantIds} />
                <div className="overlay" onClick={handleCloseHint} />
            </div>}

            <AnimatePresence>
                {selectedServent.id &&
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        transition={{ type: "spring", stiffness: 100, damping: 10, delay: 0.3 }}
                        className={getParticleEffect(getOptionState(optionId) ? getOptionState(optionId)['percent'] : -1)}
                        style={{ width: '100%', height: '100%' }}>
                        <div className="servent-chosen" onClick={handleOpenServentCard}>
                            <img src={getServentImage()} alt='' />
                            <p>{selectedServent.name}</p>
                        </div></motion.div>}
            </AnimatePresence>
            {showSearch &&
                <div className="option-search-container">
                    <SearchBar items={props.servents} possibleAnswers={validOptions.length} onSelect={handleSelectItem} onClose={handleCloseSearch} />
                    <div className="overlay" onClick={handleCloseSearch} />
                </div>}

            {showServentCard &&
                <div className='option-servent-card'>
                    <OptionCard day={props.day} name={selectedServent.name} id={selectedServent.id} rarity={getOptionState(optionId)['percent'] || -1} optionId={optionId} onClose={handleCloseServentCard} onUpdateCS={handleUseCommandSpell} />
                    <div className="overlay" onClick={handleCloseServentCard} />
                </div>}

        </div>
    );
}

export default Option;